import Settings from '@/views/Settings/Settings.vue';

const SettingsRoutes = [
    {
        path: "/settings",
        name: "Settings",
        meta: {
            requiresAuth: true
        },
        components: {
            page: Settings
        }
    }
];

export default SettingsRoutes;
